import { i18n } from '@/lang';
import { router } from '@/router';
import { store } from '@/store';
import App from '@js/App';
import events from '@/events';
import Vue from 'vue';

import '@/filters';
import '@/plugins';
import '@sass/app.scss';

// Vue config.
Vue.config.devtools = true;
Vue.config.productionTip = false;
Vue.config.silent = false;
Vue.prototype.$events = events;

// Global mixin.
Vue.mixin({
    computed: {
        project() {
            return this.$store.getters.project;
        },
        showModal() {
            return this.$store.getters.showModal;
        },
    },
});

// Global components
Vue.component('v-action', require('@cmp/Action').default);
Vue.component('v-alert', require('@cmp/Alert').default);
Vue.component('v-alert-container', require('@cmp/AlertContainer').default);
Vue.component('v-arrow', require('@cmp/Arrow').default);
Vue.component('v-avatar', require('@cmp/Avatar').default);
Vue.component('v-badge', require('@cmp/Badge').default);
Vue.component('v-breadcrumb', require('@cmp/Breadcrumb').default);
Vue.component('v-breadcrumb-item', require('@cmp/BreadcrumbItem').default);
Vue.component('v-caption', require('@cmp/Caption').default);
Vue.component('v-close', require('@cmp/Close').default);
Vue.component('v-code-box', require('@cmp/CodeBox').default);
Vue.component('v-copy-box', require('@cmp/CopyBox').default);
Vue.component('v-counter', require('@cmp/Counter').default);
Vue.component('v-dropdown', require('@cmp/Dropdown').default);
Vue.component('v-dropdown-timeframe', require('@cmp/DropdownTimeframe').default);
Vue.component('v-dropdown-toggle', require('@cmp/DropdownToggle').default);
Vue.component('v-form', require('@cmp/Form').default);
Vue.component('v-handle', require('@cmp/Handle').default);
Vue.component('v-icon', require('@cmp/Icon').default);
Vue.component('v-identifier', require('@cmp/Identifier').default);
Vue.component('v-list', require('@cmp/List').default);
Vue.component('v-list-item', require('@cmp/ListItem').default);
Vue.component('v-loader', require('@cmp/Loader').default);
Vue.component('v-menu', require('@cmp/Menu').default);
Vue.component('v-menu-item', require('@cmp/MenuItem').default);
Vue.component('v-modal', require('@cmp/Modal').default);
Vue.component('v-notice', require('@cmp/Notice').default);
Vue.component('v-notice-error', require('@cmp/NoticeError').default);
Vue.component('v-page', require('@cmp/Page').default);
Vue.component('v-page-alert', require('@cmp/PageAlert').default);
Vue.component('v-page-body', require('@cmp/PageBody').default);
Vue.component('v-page-body-sidebar', require('@cmp/PageBodySidebar').default);
Vue.component('v-page-filters', require('@cmp/PageFilters').default);
Vue.component('v-page-header', require('@cmp/PageHeader').default);
Vue.component('v-page-icon', require('@cmp/PageIcon').default);
Vue.component('v-page-section', require('@cmp/PageSection').default);
Vue.component('v-page-widget', require('@cmp/PageWidget').default);
Vue.component('v-page-widget-prop', require('@cmp/PageWidgetProp').default);
Vue.component('v-pagination', require('@cmp/Pagination').default);
Vue.component('v-panel', require('@cmp/Panel').default);
Vue.component('v-prop-list', require('@cmp/PropList').default);
Vue.component('v-ribbon', require('@cmp/Ribbon').default);
Vue.component('v-stats', require('@cmp/Stats').default);
Vue.component('v-step-number', require('@cmp/StepNumber').default);
Vue.component('v-swatch', require('@cmp/Swatch').default);
Vue.component('v-tab-bar', require('@cmp/TabBar').default);
Vue.component('v-table', require('@cmp/Table').default);
Vue.component('v-table-customers', require('@cmp/TableCustomers').default);
Vue.component('v-tag', require('@cmp/Tag').default);
Vue.component('v-tiles', require('@cmp/Tiles').default);
Vue.component('v-traits-selector', require('@cmp/TraitsSelector').default);
Vue.component('v-usage-meter', require('@cmp/UsageMeter').default);
Vue.component('v-value', require('@cmp/Value').default);
Vue.component('v-var-selector', require('@cmp/VarSelector').default);

// Forms
Vue.component('v-button', require('@forms/Button').default);
Vue.component('v-button-dots', require('@forms/ButtonDots').default);
Vue.component('v-button-google', require('@forms/ButtonGoogle').default);
Vue.component('v-button-group', require('@forms/ButtonGroup').default);
Vue.component('v-button-icon', require('@forms/ButtonIcon').default);
Vue.component('v-button-toolbar', require('@forms/ButtonToolbar').default);
Vue.component('v-checkbox', require('@forms/Checkbox').default);
Vue.component('v-date-picker', require('@forms/DatePicker').default);
Vue.component('v-days-picker', require('@forms/DaysPicker').default);
Vue.component('v-delay-picker', require('@forms/DelayPicker').default);
Vue.component('v-form-group', require('@forms/FormGroup').default);
Vue.component('v-input', require('@forms/Input').default);
Vue.component('v-input-card', require('@forms/InputCard').default);
Vue.component('v-input-color', require('@forms/InputColor').default);
Vue.component('v-input-color-swatches', require('@forms/InputColorSwatches').default);
Vue.component('v-input-coupon', require('@forms/InputCoupon').default);
Vue.component('v-input-group', require('@forms/InputGroup').default);
Vue.component('v-input-numeric', require('@forms/InputNumeric').default);
Vue.component('v-input-with-button', require('@forms/InputWithButton').default);
Vue.component('v-searchbar', require('@forms/Searchbar').default);
Vue.component('v-select', require('@forms/Select').default);
Vue.component('v-select-font', require('@forms/SelectFont').default);
Vue.component('v-selector', require('@forms/Selector').default);
Vue.component('v-switch', require('@forms/Switch').default);
Vue.component('v-textarea', require('@forms/Textarea').default);
Vue.component('v-textarea-variable', require('@forms/TextareaVariable').default);
Vue.component('v-time-picker', require('@forms/TimePicker').default);
Vue.component('v-timezone-picker', require('@forms/TimezonePicker').default);
Vue.component('v-uploader', require('@forms/Uploader').default);
Vue.component('v-uploader-file', require('@forms/UploaderFile').default);

// Builder
Vue.component('v-builder', require('@builder/Builder').default);

// Segmenter
Vue.component('v-segmenter', require('@segmenter/Segmenter').default);
Vue.component('v-segmenter-event', require('@segmenter/SegmenterEvent').default);
Vue.component('v-segmenter-page', require('@segmenter/SegmenterPage').default);

// App
new Vue({ i18n, router, store, render: h => h(App) }).$mount('#app');